import * as Animate from "react-reveal";

const stats = [
  {
    number: "01",
    value: "Since 2018",
    desc: "Building practical pathways from learning to opportunity",
  },
  {
    number: "02",
    value: "200K+",
    desc: "Talent within the Utiva ecosystem",
  },
  {
    number: "03",
    value: "200+",
    desc: "Faculty and expert network",
  },
  {
    number: "04",
    value: "30 countries",
    desc: "A growing, globally connected community",
  },
];

const AboutStatsSection = () => {
  return (
    <section className="bg-hire-tint-blue py-10 md:py-12 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {stats.map((stat, index) => (
            <Animate.Fade bottom key={stat.number}>
              <div
                className={`h-full ${
                  index !== stats.length - 1
                    ? "lg:border-r lg:border-hire-line lg:pr-6"
                    : ""
                }`}
              >
                <span className="text-secondary font-poppins text-xs font-extrabold">
                  {stat.number}
                </span>
                <strong className="block font-poppins text-xl text-primary font-extrabold mt-1 mb-1.5">
                  {stat.value}
                </strong>
                <span className="text-gray font-poppins text-sm leading-snug block">
                  {stat.desc}
                </span>
              </div>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutStatsSection;
